import { SET_DESIGN_ERROR, CLEAR_DESIGN_ERROR } from "../constants/DesignError";

export const setDesignError = (value:any) => ({
  type: SET_DESIGN_ERROR,
  payload: value
});

export const clearDesignError = () => ({
  type: CLEAR_DESIGN_ERROR,
});